import  api from "./axiosAPI";
// 판매 관련 API 정의
export const saleAPI = {
    /*
    * 현재 세일 기간 saleId 확인
    * param : none
    {
      "seasonStatus": {
        "OG": "OgSale25",
        "WhiteList": "WlSale25",
        "Public": "PubSale25"
      },
    }
    * */
    seasonStatus: () => api.get('PreSaleStatus'),
    /*
    * 현재 외부마켓 솔드아웃 확인
    * param : none
    {
      "externalMarketStatus": {
        "Havah": true,
        "Pala": true,
        "Altava": true,
        "Hyper": true,
        "Tmon": true
      },
    }
    * */
    externalMarketStatus: () => api.get('ExternalMarketStatus'),
    revealNft: (param) => api.post('RevealNft',param),

}